module.exports = __webpack_public_path__ + "static/media/successIcon.2e305b66.svg";